// extracted by mini-css-extract-plugin
export default {"button":"MagicButton_button__j3Gmp","sparkle":"MagicButton_sparkle__R4vDq","loading":"MagicButton_loading__litPb","loadingAnimation":"MagicButton_loadingAnimation__fv+Pt"};